import { useCallback } from "react";

import { useAsyncFn } from "./useAsync";
import { getErrorMsg } from "../helpers/methods";
import { useSnackbarAlert } from "../context/snackbarAlert";
import { useTranslation } from "react-i18next";

export const useCrudFn = (onCreate, onUpdate, onDelete, type = "object") => {
  const onCreateFn = useAsyncFn(onCreate)
  const onUpdateFn = useAsyncFn(onUpdate)
  const onDeleteFn = useAsyncFn(onDelete)
  const snackbarAlert = useSnackbarAlert();
  const { t } = useTranslation();


  const onCreateObject = useCallback((data, onCreateRefetch, onError) => {
    onCreateFn
      .execute(data)
      .then((res) => {
        snackbarAlert.openSuccessSnackbarAlert(
          t(`snackbar_alert.${type}_created`)
        );
        if (onCreateRefetch) onCreateRefetch(res)
        
      })
      .catch((err) => {
        snackbarAlert.openErrorSnackbarAlert(
          getErrorMsg(err.data),
          t(`snackbar_alert.occurred_error_during_creating_${type}`)
        );
        
      if (onError) onError();
      });
  }, [])

const onUpdateObject = useCallback((id, data, onUpdateRefetch, onError) => {
  onUpdateFn
    .execute(id, data)
    .then((res) => {
      snackbarAlert.openSuccessSnackbarAlert(
        t(`snackbar_alert.${type}_updated`)
      );
      if (onUpdateRefetch) onUpdateRefetch(res);
    })
    .catch((err) => {
      snackbarAlert.openErrorSnackbarAlert(
        getErrorMsg(err.data),
        t(`snackbar_alert.occurred_error_during_updating_${type}`)
      );
      if (onError) onError();
    });
}, [onUpdateFn, snackbarAlert, t]);

  const onDeleteObject = useCallback((id, onRemoveRefetch, onError) => {
    onDeleteFn
      .execute(id)
      .then((res) => {
        snackbarAlert.openSuccessSnackbarAlert(
          t(`snackbar_alert.${type}_removed`)
        );
        if(onRemoveRefetch) onRemoveRefetch(res)
      })
      .catch((err) => {
        snackbarAlert.openErrorSnackbarAlert(
          getErrorMsg(err.data),
          t(`snackbar_alert.occurred_error_during_removing_${type}`)
        );
      if (onError) onError();
      });
  }, [])


  return {
    onCreateObject,
    onUpdateObject,
    onDeleteObject,
    isCreatingLoading: onCreateFn.loading,
    isUpdatingLoading: onUpdateFn.loading,
    isDeletingLoading: onDeleteFn.loading,
  };
};
